module.exports = __webpack_public_path__ + "static/media/arrow.bdc84ed3.svg";